// extracted by mini-css-extract-plugin
export default {"body":"expired_body__vitxm"};